import { createContext, useContext } from 'react';

/** True when rendered inside AuthenticatedShell (layout already mounted). */
export const DashboardShellContext = createContext(false);

export function useInDashboardShell() {
  return useContext(DashboardShellContext);
}
